import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import swal from "sweetalert";
import { API_URL } from "../../../../core/config/env";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl } from "../../../../core/helpers/message-helper";
import useUser from "../../../../core/hooks/use-user";
import { cerrarRequerimiento } from "../../services/requerimientos-service";

const ListarRequerimientos = ({ modalState }) => {
    const { requerimientos } = modalState.data;

    const { getAccessToken } = useUser();
    const token = getAccessToken();

    let tableButtons = [];

    tableButtons.push({
        titleAttr: "Cerrar requerimiento",
        text: '<i class="fas fa-check"></i>',
        className: "btn btn-sm btn-secondary",
        action: async (e, dt) => {
            const data = dt.row({ selected: true }).data();
            if (!data) return;

            const value = await swal({
                title: "Confirmación",
                text: `¿Seguro que desea cerrar el requerimiento?`,
                icon: "info",
                buttons: {
                    cancelar: {
                        text: "Cancelar",
                        className: "btn-danger",
                    },
                    aceptar: {
                        text: "Aceptar",
                        className: "btn-success",
                    },
                },
            });

            switch (value) {
                case "cancelar":
                    sweetAl.warning("No se ha cerrado el requerimiento");
                    break;
                case "aceptar": {
                    const resp = await cerrarRequerimiento(data);

                    if (!resp.status) {
                        return sweetAl.error(
                            "Ha ocurrido un error al cerrar el requerimiento"
                        );
                    }

                    sweetAl.success("Se ha cerrado el requerimiento");
                    dt.ajax.reload();
                    break;
                }
            }
        },
    });

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "requerimientos-software",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        destroy: true,
        dom: "Bfrtip",
        id: "tableRequerimientos",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/requerimientos/${requerimientos.id}`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: () => {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de requerimientos"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombreSoftware" },
            { data: "nombreRequerimiento" },
            { data: "descripcion" },
            { data: "caracteristicas" },
            { data: "nombreEstado" },
        ],
        columnDefs: [
            {
                targets: [5],
                createdCell: function (td, cellData) {
                    td.classList.add(
                        cellData == "Realizado"
                            ? "text-success"
                            : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <Modal
            isOpen={modalState.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader className="bg-secondary text-white text-bold">
                {modalState.title}
            </ModalHeader>
            <ModalBody>
                <Datatable options={dtOptions}>
                    <table
                        className="w-100 table table-hover"
                        id="tableRequerimientos"
                    >
                        <thead className="bg-dark">
                            <tr>
                                <th className="text-center text-white">Id</th>
                                <th className="text-center text-white">
                                    Software
                                </th>
                                <th className="text-center text-white">
                                    Requerimiento
                                </th>
                                <th className="text-center text-white">
                                    Descripción
                                </th>
                                <th className="text-center text-white">
                                    Caracteristicas
                                </th>
                                <th className="text-center text-white">
                                    Estado
                                </th>
                            </tr>
                        </thead>
                    </table>
                </Datatable>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        key="close"
                        color="secondary"
                        onClick={() => {
                            modalState.close();
                        }}
                    >
                        <i className="fas fa-trash mr-2"></i>
                        Cancelar
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );
};

ListarRequerimientos.propTypes = {
    modalState: PropTypes.object,
};

export default ListarRequerimientos;
